import React from "react";
import { Image } from "antd";

const photosForLeather = [
  { id: 1, Photo: "./assets/leather1.png" },
  { id: 2, Photo: "./assets/leather2.png" },
  { id: 3, Photo: "./assets/leather3.png" },
];

export const TheLeatherraft = () => {
  return (
    <div className="bg-[#F5F5F5] border-t p-[40px] mt-[40px border-gray-300 animate-slideInLeft">
      <div className="font-oswald font-bold text-[30px] mb-[20px] text-center md:text-left">
        <h2>
          The Leather Crafts Site:
          <a
            className="text-blue-400 text-[20px]"
            href="https://arpi.gorvinws.com"
          >
            =Link=
          </a>
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-[15px] justify-center items-center">
        {photosForLeather.map((item, index) => (
          <div key={index} className="p-[15px] flex justify-center">
            <Image className="w-[200px]" src={item.Photo} alt="web-fotos" />
          </div>
        ))}
      </div>
    </div>
  );
};
